import {connect} from 'react-redux';
import {reduxForm, reset, change} from 'redux-form';
import {push} from 'react-router-redux';
import moment from "moment";

import {saveChildData, getValues} from './child';
import ChildForm from './ChildForm';
import {getIsInternalUse} from "../../main";
import * as constants from '../../constants';

function validate(values) {
  let errors = {};
  if (!values.vorname) {
    errors.vorname = "Bitte geben Sie den Vornamen Ihres Kindes an.";
  }
  if (!values.nachname) {
    errors.nachname = "Bitte geben Sie den Nachnamen Ihres Kindes an.";
  }
  if (!values.geburtsdatum) {
    errors.geburtsdatum = "Bitte geben Sie das Geburtsdatum Ihres Kindes an.";
  }
  if (values.geburtsdatum && moment(values.geburtsdatum)) {
    let geburtsdatum = moment(values.geburtsdatum, constants.DATE_FORMAT);
    if(! geburtsdatum.isValid()) {
      errors.geburtsdatum = "Das Datum muss im Format TT.MM.JJJJ angegeben werden."
    }
  }
  if (!values.tshirtGroesse) {
    errors.tshirtGroesse = "Bitte geben Sie die T-Shirt-Größe Ihres Kindes an.";
  }
  if (!values.geschlecht) {
    errors.geschlecht = "Bitte geben Sie das Geschlecht des Kindes an.";
  }

  return errors;
}

// Handle submitted data
function onSubmit(values, dispatch, kindNr) {
  dispatch(saveChildData(
    kindNr,
    values.vorname,
    values.nachname,
    values.geburtsdatum,
    values.tshirtGroesse,
    values.tetanusImpfungVorhanden,
    values.geschlecht,
    values.allergien,
    values.sonstiges,
    )
  );
  dispatch(reset('child'));
}

// Decorate the form component
const ReduxFormDecoratedChildForm = reduxForm({
  form: 'child',
  destroyOnUnmount: false,
  validate: validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(ChildForm);

// You have to connect() to any reducers that you wish to connect to yourself
function mapStateToProps(state, props) {
  let initialValues = {
    nachname: state.parent.get('nachname', '')
  };
  let childData = getValues(state.children, props.kindNr);
  if (childData !== null) {
    initialValues = childData;
  }

  return {
    myErrors: state.form.child && state.form.child.syncErrors,
    formValues: state.form.child && state.form.child.values,
    initialValues,
    isInternalUse: getIsInternalUse(state.main),
    viewportWidth: state.main.get('viewportWidth'),
  }
}

function mapDispatchToProps(dispatch, props) {
  return {
    saveChildData: dispatch(saveChildData),
    onPrevious: () => {
      dispatch(reset('child'));
      dispatch(push(props.previousRoute));
    },
    onNext: (values) => {
      onSubmit(values, dispatch, props.kindNr);
      dispatch(reset('child'));
      dispatch(push(props.nextRoute));
    },
    onSummary: (values) => {
      onSubmit(values, dispatch, props.kindNr);
      dispatch(reset('child'));
      dispatch(push(props.summaryRoute));
    },
    onBirthdayBlur: (event, newValue, previousValue) => {
      let geburtsdatum = moment(newValue, constants.DATE_FORMAT);
      if(geburtsdatum.isValid()) {
        event.preventDefault();
        dispatch(change('child', 'geburtsdatum', geburtsdatum.format(constants.DATE_FORMAT)));
      }
    }
  }
}

const ConnectedChildForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxFormDecoratedChildForm);

export default ConnectedChildForm;



// WEBPACK FOOTER //
// ./src/components/child/ChildComponent.js